// Webpack Imports
import * as bootstrap from 'bootstrap';
import $ from "jquery";

(function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});


	/**
	 * converts images .svg to svg objects
	 */
	$('img[src$=".svg"]').each(function() {
		var $img = jQuery(this);
		var imgURL = $img.attr('src');
		var attributes = $img.prop("attributes");

		$.get(imgURL, function(data) {
			// Get the SVG tag, ignore the rest
			var $svg = jQuery(data).find('svg');

			// Remove any invalid XML tags
			$svg = $svg.removeAttr('xmlns:a');

			// Loop through IMG attributes and apply on SVG
			$.each(attributes, function() {
				$svg.attr(this.name, this.value);
			});

			// Replace IMG with SVG
			$img.replaceWith($svg);

			$(document).find('svg').show();
		}, 'xml');
	});

	/**
	 * if site has woocommerce
	 */
	if (typeof woo !== 'undefined' && woo) {
		/** AJAX to refresh cart content */
		$( document.body ).on( 'updated_cart_totals', function(event){
			$.ajax({
				url : '/wp-json/wc/v3/cart/count-items',
				success : function( data ) {
					$(document).find('.cart-contents .cart-count').html(data);
				}
			});
			$.ajax({
				url : '/wp-json/wc/v3/cart/totals',
				success : function( data ) {
					$(document).find('.cart-contents .amount').html(data);
				}
			});
		});
	}

	/**
	 * Make whole li clickable
	 */
	$(document).on('click', '#widget-area .wc-layered-nav-term', function() {
		$(this).find('a')[0].click();
	})
})();
